<template>
  <div>

    <div v-for="(level, index) in levels" :class="{'hidden' : !hasItems(index) }" class="row">
      <div class="col-md-3 text-lg-right">{{ $t('isco_selector.levels')[index] }}</div>
      <div class="col-md-9">
        <div class="dropdown dropdownisco">
          <button :disabled="readOnly"
                  :id="`dropdownIscoButton${index}`"
                  :class="{'btn-primary' : isActive(index) }"
                  class="btn dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
            {{ $t(selected[index] || placeholder) }}
          </button>
          <div :aria-labelledby="`dropdownIscoButton${index}`" class="dropdown-menu">
            <a v-for="occupation in level" :key="occupation.code" class="dropdown-item" @click.prevent="setLevel(index, occupation.code)">{{ $t(occupation.code) }}</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.btn.dropdown-toggle {
  max-width: 100%;
  overflow: auto;
  text-overflow: ellipsis;
}
</style>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'ISCOSelector',

  props: {
    readOnly: { type: Boolean, default: true }
  },

  data: () => ({
    levels: [
      {},
      {},
      {},
      {}
    ],
    placeholder: 'choose',
    occupation: '',
    selected: [
      '',
      '',
      '',
      ''
    ]
  }),

  computed: {
    ...mapGetters({
      isco: 'isco/isco'
    })
  },

  created () {
    this.levels[0] = this.search('')
  },

  methods: {
    hasItems (level) {
      return this.levels[level].length > 0
    },

    isActive (level) {
      return this.selected[level] != ''
    },

    isValid () {
      for (let i = 0; i < 4; i++) {
        if (!this.hasItems(i)) {
          break
        }

        if (!this.isActive(i)) { return false }
      }

      return true
    },

    recSearch (code, selected) {
      for (var i = 0; i < this.isco.length; i++) {
        var occupation = this.isco[i]
        if (occupation['code'] == code) {
          selected.push(code)
          this.recSearch(occupation['parent'], selected)
          break
        }
      }
    },

    reset () {
      this.levels = [{}, {}, {}, {}]
      this.selected = ['', '', '', '']
      this.levels[0] = this.search('')
    },

    search (code) {
      var codes = []

      for (var i = 0; i < this.isco.length; i++) {
        var occupation = this.isco[i]
        if (occupation['parent'] == code) {
          codes.push({
            code: occupation['code'],
            description: occupation['description']
          })
        }
      }

      return codes
    },

    setLevel (level, code) {
      Vue.set(this.selected, level, code)

      this.occupation = code

      if (level < 3) {
        this.levels[level + 1] = this.search(code)
        if (this.hasItems(level + 1)) {
          this.occupation = ''
        }
      }

      for (var i = level + 1; i < 4; i++) {
        this.levels[i] = []
        Vue.set(this.selected, level, code)
        Vue.set(this.selected, i, '')
      }

      if (level < 4) {
        this.levels[level + 1] = this.search(code)
      }

      // Emit validity.
      this.$emit('valid', this.isValid())
    },

    setOccupation (code) {
      let selected = []

      if (!code || code.length == 0) {
        this.reset()
      } else {
        this.recSearch(code, selected)
        selected = selected.reverse()
      }

      for (var i = 0; i < selected.length; i++) { this.setLevel(i, selected[i]) }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ISCOSelector.vue